import { Linear as LinearScale } from '@antv/scale';
export const Linear = (options) => {
    return new LinearScale(options);
};
Linear.props = {};
//# sourceMappingURL=linear.js.map